<template>
  <div class="content">
    <Header></Header>
    <div class="nav">
      <span class="">{{$t('Guidance')}}</span>
    </div>
    <div class="personal-info" >
      <div class="information2">
        <div class="faq-content" v-if="list!=''">
          <div class="">
            <p v-html="list"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/header'
export default {
  components:{
    Header
  },
  data() {
    return {
      list:''

    }
  },
  watch: {

  },
  computed:{
  },
  mounted() {
    let that = this;
  },
  created(){
    this.getHome()
  },
  methods: {
    back(){
      this.$router.go(-1);
    },
    getHome() {
      let that = this;
      that.$parent.loadModal(true);
      let data = {
        type: '3'
      }
      that.$api.post('/api/index/help', data, r => {
        that.$parent.returnCode(r, function () {
          if (localStorage.getItem('lang') == 'en') {
            that.list = r.data.content
          } else {
            // that.list = r.data.mm_content
            that.list = r.data.content
          }
          that.$parent.loadModal(false);
        });

      })
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/guidance.vue